export default {
  name: 'Header',
}